export default __webpack_public_path__ + "static/media/monthlySystem.c73ac4e3.png";